import { render, staticRenderFns } from "./PaperTab.vue?vue&type=template&id=6fe1564c&"
import script from "./PaperTab.vue?vue&type=script&lang=js&"
export * from "./PaperTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports